import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: "Chris",
    lastName: "Levin",
    username: "chrislevin22",
    password: "chrislevin@123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "Co-founder and CTO of @nextgen_io",
    website: "https://chrislevin.tech",
    profilePicture: "https://i.pravatar.cc/300?img=12",
    followers: [],
    following: [],
  },
  {
    _id: uuid(),
    firstName: "Veronica",
    lastName: "Dane",
    username: "veron_d12",
    password: "veron@123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "Covering startups @businessline | Ex-Microsoft",
    website: "https://veronicane.info",
    profilePicture: "https://i.pravatar.cc/300?img=5",
    followers: [],
    following: [],
  },
  {
    _id: uuid(),
    firstName: "Lucy",
    lastName: "Staniforth",
    username: "lucy_st4",
    password: "lucy@123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "Author | 2 NYTs BestSellers | Stanford lecturer",
    website: "https://readwithlucy.com",
    profilePicture: "https://i.pravatar.cc/300?img=32",
    followers: [],
    following: [],
  },
  {
    _id: uuid(),
    firstName: "Stuart",
    lastName: "Wood",
    username: "stuart_99",
    password: "stuart@123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "AE Intern @Google | YouTube Creator",
    website: "https://stuartwood.tech",
    profilePicture: "https://i.pravatar.cc/300?img=4",
    followers: [],
    following: [],
  },
  {
    _id: uuid(),
    firstName: "Rachel",
    lastName: "Daly",
    username: "rachel_dy3",
    password: "rachel@123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "Founder @nrwl_co | Pizzatarian, programmer & music maker",
    website: "https://rachedaly.com",
    profilePicture: "https://i.pravatar.cc/300?img=47",
    followers: [],
    following: [],
  },
];
